import React, { useState } from 'react';
import logo from '../logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="relative">
      <nav className="bg-cream shadow-md px-4 py-4 flex justify-between items-center z-20 relative">
        {/* Logo Image */}
        <div className="flex items-center">
         <a href='/'> <img
            src={logo}
            alt="MyWebsite Logo"
            className="h-12 w-auto" // Ensures height stays fixed, width adjusts proportionally
          /></a>
        </div>

        {/* Hamburger button */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-600 focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Desktop links */}
        <ul className="hidden md:flex md:space-x-6  text-gray-600  font-bold font-garet">
          <li className="hover:text-pink cursor-pointer"><a href='/'>Home</a></li>
          <li className="hover:text-pink cursor-pointer"><a href='/about'>About</a></li>
          <li className="hover:text-pink cursor-pointer"><a href='/contact'>Contact</a></li>
        </ul>
      </nav>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <ul className="absolute bg-cream top-full left-0 w-full shadow-md flex flex-col text-gray-700 font-garet font-medium md:hidden z-10">
          <li className="px-4 py-3 border-b cursor-pointer"><a href='/'>Home</a></li>
          <li className="px-4 py-3 border-b cursor-pointer"><a href='/about'>About</a></li>
          <li className="px-4 py-3 cursor-pointer"><a href='/contact'>Contact</a></li>
        </ul>
      )}
    </div>
  );
};

export default Navbar;
